import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ReportJobsService, ReportJobStatus } from '../../../services/report-jobs.service';
import { ReportHubService } from '../../../services/report-hub.service';

@Component({
  selector: 'app-recent-report-jobs',
  templateUrl: './recent-report-jobs.component.html'
})
export class RecentReportJobsComponent implements OnInit, OnDestroy {
  recentJobs: ReportJobStatus[] = [];
  private hubSub!: Subscription;
  private pollSub?: Subscription;

  constructor(
    private reportJobsService: ReportJobsService,
    private reportHubService: ReportHubService
  ) {}

  ngOnInit(): void {
    this.loadJobs();

    this.hubSub = this.reportHubService.reportStatusChanged$.subscribe(notification => {
      const idx = this.recentJobs.findIndex(j => j.id === notification.jobId);
      if (idx >= 0) {
        this.recentJobs[idx] = {
          ...this.recentJobs[idx],
          status: notification.status,
          fileName: notification.fileName,
          errorMessage: notification.errorMessage
        };
        this.managePoll();
      } else {
        this.loadJobs();
      }
    });
  }

  ngOnDestroy(): void {
    this.hubSub?.unsubscribe();
    this.pollSub?.unsubscribe();
  }

  loadJobs(): void {
    this.reportJobsService.getMyJobs().subscribe({
      next: (jobs) => {
        this.recentJobs = jobs;
        this.managePoll();
      },
      error: () => this.recentJobs = []
    });
  }

  private managePoll(): void {
    const hasPending = this.recentJobs.some(j => j.status === 'Queued' || j.status === 'Processing');
    if (hasPending && !this.pollSub) {
      this.pollSub = interval(5000).subscribe(() => this.loadJobs());
    } else if (!hasPending && this.pollSub) {
      this.pollSub.unsubscribe();
      this.pollSub = undefined;
    }
  }

  download(jobId: string, fileName?: string | null): void {
    this.reportJobsService.downloadReport(jobId, fileName || undefined);
  }

  getReportTypeName(type: string): string {
    const names: Record<string, string> = {
      'IncomeReceipt': 'Comprobantes de Ingreso',
      'ExpenseReceipt': 'Comprobantes de Egreso',
      'BankReport': 'Reporte Bancario',
      'WorkOrders': 'Ordenes de Trabajo',
      'Portfolio': 'Cartera',
      'ProjectEnrollments': 'Inscripciones por Proyecto',
      'ProjectProgramDetail': 'Detalle Programa Proyecto',
      'BudgetExecution': 'Ejecución Presupuestal',
      'BankReconciliation': 'Conciliación Bancaria',
      'PunishedPortfolio': 'Cartera Castigada',
      'WompiConsolidated': 'Consolidado Wompi',
      'WompiReport': 'Pagos Wompi'
    };
    return names[type] || type;
  }
}
